import {
  FETCH_SPECIAL_OFFERS_REQUEST,
  FETCH_SPECIAL_OFFERS_SUCCESS,
  FETCH_SPECIAL_OFFERS_FAILURE
} from '../../actionTypes/specialOffersActionTypes'

const fetchSpecialOffersRequest = (payload, baseUrl) => ({
  type: FETCH_SPECIAL_OFFERS_REQUEST,
  payload,
  baseUrl
})

const fetchSpecialOffersSuccess = payload => ({
  type: FETCH_SPECIAL_OFFERS_SUCCESS,
  payload
})

const fetchSpecialOffersFailure = payload => ({
  type: FETCH_SPECIAL_OFFERS_FAILURE,
  payload
})

export { fetchSpecialOffersRequest, fetchSpecialOffersSuccess, fetchSpecialOffersFailure }
